
import "./App.css";
import { Route, Routes } from "react-router-dom";
import { useAuthenticator } from '@aws-amplify/ui-react';
import { Amplify } from "aws-amplify";

// Import your Amplify configuration from aws-exports.js
import awsExports from "./aws-exports";

import { useSharedState } from './context/sharedState';

import Home from "./pages/home/Home";
import Participants from "./pages/participants/Participants";
import Sensors from "./pages/sensors/sensors";
import Dashboard from "./pages/dashboard/dashboard";
import NotFound from "./pages/NotFound/notfound";
import Users from "./pages/users/users";
import LandingPage from "./pages/landingPage/LandingPage";
import Profile from "./pages/profile/Profile";

import DashboardMobile from "./pages/dashboardmobile/dashboardmobile"

// Configure Amplify with the generated configuration
Amplify.configure(awsExports);

function App() {

  const { user } = useAuthenticator((context) => [context.user]);
  const { isMobile } = useSharedState();

  return (   
        <>
          <Routes>
            <Route
                path="/"
                element={
                  user ? <Home /> : <LandingPage />
                }
            >
              <Route index element={isMobile ? <DashboardMobile/> : <Dashboard />} />
              <Route path="participants" element={<Participants />} />
              <Route path="sensors" element={<Sensors />} />
              <Route path="users" element={<Users />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/profile" element={user ? <Profile /> : <LandingPage />} />
            {/* <Route path="/studies" element={user ? <Studies /> : <LandingPage />} /> */}
          </Routes>
        </>
  );
}

export default App;


// 4. Make use of <ProtectedRoute> element
// 5. Make proper nesting <Authenticator> component
